<template>
    <div class="search_input">

        <div class="search_icon"><i class="icon-magnifier"></i></div>
        <input type="text"
            v-model="query"
            :placeholder="placeholder"
            @focus="toggleResults(true)"
            @blur="toggleResults(false)"
            @input="$emit('queryChange', $event.target.value)">

        <searchDropdown class="search_bar_dropdown"  :pose="searchOpen ? 'visible' : 'hidden'">

            <!-- <div class="no_search_results" v-if="!hasResults">
                <span>{{ $t('components.searchBar.noResultsNotice') }}</span>
            </div> -->

            <slot />

        </searchDropdown>

    </div>
</template>

<script>
import posed from 'vue-pose';

export default {
    name: 'SearchBar',
    props: {
        hasResults: {
            type: Boolean,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        }
    },
    components: {
        searchDropdown: posed.div({
            visible: {
                opacity: 1,
                height: 'auto',
                transition: { duration: 250, ease: 'easeInOut' }
            },
            hidden: {
                opacity: 0,
                height: 0,
                transition: { duration: 250, ease: 'easeInOut' }
            }
        })
    },
    data(){
        return {
            query: "",
            searchOpen: false
        }
    },
    methods: {
        toggleResults(visibility){
            setTimeout(() => this.searchOpen = visibility, 100);
        }
    }
}
</script>

<style lang="scss">
.search_input{
    position: relative;
    flex: 1;
    display: flex;
    .search_icon{
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 1.5rem;
    }
    input{
        width: 100%;
        border: none;
        outline: none!important;
    }
    .search_bar_dropdown{
        // margin-left: 10%;
        z-index: 5;
        left: 0;
        right: 0;
        position: absolute;
        width: calc(100% + 1px);
        background: white;
        top: 60px;
        border: 1px solid #ebebeb;
        border-top: none;
        overflow: auto;
        box-shadow: 0 5px 10px $white-ter;
        max-height: 80vh;
        .no_search_results{
            span{
                padding: 18px 30px;
                display: block;
            }
        }
    }
}
</style>